import { FC } from 'react'
import { DefaultProps } from '../../common'

type AlertErrorIconProps = DefaultProps & {
  width?: number
  height?: number
}

export const AlertErrorIcon: FC<AlertErrorIconProps> = ({
  className,
  id,
  testId,
  ariaLabel,
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      className={className}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(!ariaLabel ? { 'aria-hidden': true, role: 'presentation' } : {})}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.3" cx="20" cy="20" r="20" fill="#FDABA9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.25 20C10.25 14.6152 14.6152 10.25 20 10.25C25.3848 10.25 29.75 14.6152 29.75 20C29.75 25.3848 25.3848 29.75 20 29.75C14.6152 29.75 10.25 25.3848 10.25 20ZM20 16.25C20.4142 16.25 20.75 16.5858 20.75 17V20.75C20.75 21.1642 20.4142 21.5 20 21.5C19.5858 21.5 19.25 21.1642 19.25 20.75V17C19.25 16.5858 19.5858 16.25 20 16.25ZM20 24.5C20.4142 24.5 20.75 24.1642 20.75 23.75C20.75 23.3358 20.4142 23 20 23C19.5858 23 19.25 23.3358 19.25 23.75C19.25 24.1642 19.5858 24.5 20 24.5Z"
        fill="#FB5653"
      />
    </svg>
  )
}
